import { Dialog } from 'primereact/dialog'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Button } from 'primereact/button'
import { useMountEffect } from 'primereact/hooks'
import { assign, cloneDeep, isEmpty, max, padStart } from 'lodash'
import { CommonContext } from '../common/context/commonContext'
import {
    InventoryGoodsDetail,
    InventoryGoodsMoveDialogProps,
    LocationArea,
    LocationBay,
    LocationCol,
    LocationDetail,
    LocationRow,
    LocationSaveDialogProps,
    LocationSector,
} from '../../types/inventory'
import { Divider } from 'primereact/divider'
import { CommonCode } from '../../types/common'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { TabPanel, TabView } from 'primereact/tabview'
import PdaIconTabHeader from '../common/PdaIconTabHeader'
import IncomingKeepGoods from '../incoming/IncomingKeepGoods'
import IncomingDayGoods from '../incoming/IncomingDayGoods'
import GoodsMove from './GoodsMove'
import GoodsReturn from './GoodsReturn'
import CenterMove from './CenterMove'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const InventoryGoodsMoveDialog = (props: InventoryGoodsMoveDialogProps) => {
    const { $toast, $http, $alert } = useContext(CommonContext)
    const { t } = useTranslation()
    const [activeIndex, setActiveIndex] = useState<number>(0)
    const [goods, setGoods] = useState<InventoryGoodsDetail>({
        rowNum: 0,
        lctSeq: '',
        goodsId: '',
        goodsNm: '',
        centerId: '',
        centerNm: '',
        invnSeq: 0,
        goodsQty: 0,
        pckGoodsQty: 0,
        avlbGoodsQty: 0,
        gdslsUnitCd: '',
        specTxt: '',
        shlfYmd: '',
        shlfYmdFm: '',
        shlfRemainDay: 0,
        strgDay: 0,
        prchUnitAmt: 0,
        imageUri: '',
        shlfYn: '',
        lotNo: '',
        sysCd: '',
    })

    useMountEffect(() => {
        if (!props.visible) return
        if (!props.data) return
        setGoods(props.data)
    })

    const onClickSave = async () => {
        if (!goods.lctSeq) return

        if (isEmpty(goods.lctSeq)) {
            $alert({
                icon: 'info',
                title: t(tokens.common.add_zone),
                text: t(tokens.inventory.enter_location_zone_name),
            })
            return
        }

        const isConfirm = await $alert({
            icon: 'info',
            title: t(tokens.common.add_zone),
            text: t(tokens.inventory.confirm_location_zone_addition),
            isConfirm: true,
        })

        if (!isConfirm) return

        const result = await $http().put('/inventory/add-area', goods)
        if (result) {
            $toast({ title: t(tokens.common.success), text: t(tokens.inventory.zone_added), icon: 'success' })
            props.onHide(true)
        }
    }

    const onChange = (type: string, value: string) => {}
    const onClickHide = (isChange: boolean) => {
        props.onHide(isChange)
    }

    const header = (title: string) => {
        return <div className="col-12 flex grid py-0">{title}</div>
    }

    return (
        <Dialog
            visible={props.visible}
            onHide={() => props.onHide(false)}
            closable={false}
            className="p-0"
            contentClassName="pb-1 inventory-dialog"
            headerClassName="p-1"
        >
            {props.visible && (
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header={<PdaIconTabHeader icon="" title={t(tokens.inventory.stock_movement)} />}>
                        {activeIndex === 0 ? <GoodsMove data={goods} onHide={(e) => onClickHide(e)} /> : null}
                    </TabPanel>
                    <TabPanel header={<PdaIconTabHeader icon="" title={t(tokens.common.supplier_return)} />}>
                        {activeIndex === 1 ? <GoodsReturn data={goods} onHide={(e) => onClickHide(e)} /> : null}
                    </TabPanel>
                    <TabPanel header={<PdaIconTabHeader icon="" title={t(tokens.common.interwarehouse_transfer)} />}>
                        {activeIndex === 2 ? <CenterMove data={goods} onHide={(e) => onClickHide(e)} /> : null}
                    </TabPanel>
                </TabView>
            )}
        </Dialog>
    )
}

export default InventoryGoodsMoveDialog
